import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import { groupBy } from "./../helpers";
import toastr from "toastr";
import moment from "moment/moment";
import { postData } from "../services/api";
import { useParams, useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { Document, pdf } from "@react-pdf/renderer";
import SuccessionPlanReport from "./pdf/SuccessionPlanReport";
import { API_URL } from "../config/host";
import ApprovalPopup from "../components/popup/ApprovalPopup";
import AlertPopup from "../components/popup/AlertPopup";
import SuccessionPlanAllReportMain from "./pdf/SuccessionPlanAllReportMain";
import AdditionalPlanPopup from "../components/popup/AdditionalPlanPopup";
import { Tooltip } from "react-tooltip";
import DeletePopup from "../components/DeletePopup";
import ConfirmationPopup from "../components/popup/ConfirmationPopup";
import { useDispatch } from "react-redux";
import { authLogin, authLogout } from "../store/authSlice";
import EmergencyReplacementPlanReport from "./pdf/EmergencyReplacementPlanReport";
import { useTranslation } from "react-i18next";
import TrialAlertPopup from "../components/popup/TrialAlertPopup";
import SendReminderPopup from "../components/popup/SendReminderPopup";
import DashboardPlanTrackingSkeleton from "../components/loader/DashboardPlanTrackingSkeleton";
import { SuccessonPlanLimitMessage } from "../helpers";
import DashBoardReportCenter from "../components/section/Dashboard/DashBoardReportCenter";
import AvgOfQuestionTier from "../components/section/Dashboard/AvgOfQuestionTier";
import CardTable from "../components/elements/CardTable";
import AddEditCompanyPosition from "../components/popup/AddEditCompanyPosition";
import { useSettingsModal } from "../Context/SettingsContext";
import { PositionTier } from "../constant/Constant";
import DashboardButtonGroup from "../components/Common/DashboardButtonGroup";
import EligibilityOverviewReport from "../components/section/Dashboard/EligibilityOverviewReport";

const Dashboard = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Dashboard"
  );
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const isTrial = localStorage.getItem("isTrial");
  const user = useSelector((state) => state.auth?.user);
  const { tierType } = useSettingsModal();
  const [retirementWindow, setRetirementWindow] = useState([]);
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState({});
  const [ownSuccessor, setOwnSuccessors] = useState([]);
  const [successors, setSuccessors] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [predictorWeight, setPredictorWeight] = useState(0);
  const [experienceWeight, setExperienceWeight] = useState(0);
  const [concernsWeight, setConcernWeight] = useState(0);
  const [performanceWeight, setPerformanceWeight] = useState(0);
  const [educationWeight, setEducationWeight] = useState(0);
  const [yearWithCompanyWeight, setYearWithCompany] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  
  const [isSuccessorCount, setIsSuccessorCount] = useState(false);
  const [successorCount, setSuccessorCount] = useState(0);
  const [concernHeadings, setConcernHeadings] = useState([]);
  const [predictorsHeading, setPredictorsHeading] = useState([]);
  const [enabledAdditionalPlanPopup, setEnabledAdditionalPlanPopup] =
    useState(false);
  const [enabledApprovalPopup, setEnabledApprovalPopup] = useState(false);
  const [enabledAlertPopup, setEnabledAlertPopup] = useState(false);
  const [enabledDeletePopup, setenabledDeletePopup] = useState(false);
  const [enabledConfirmationPopup, setEnabledConfirmationPopup] =
    useState(false);
  const [enabledSendReminderPopup, setEnabledSendReminderPopup] =
    useState(false);
  const [actionValue, setActionValue] = useState({});
  const [currentId, setCurrentId] = useState("");

  const [isChecking, setIsChecking] = useState(false);
  const [planData, setPalnData] = useState({});

  const [enabledTrialPopup, setEnabledTrialPopup] = useState(false);

  const path = window.location.pathname.replace(/[/]/g, "").replace(/\s/g, "");

  const [showSkeleton, setShowSkeleton] = useState(true);
  const [enabledPrivatePopup, setEnabledPrivatePopup] = useState(false);

  const [readinessData, setReadinessData] = useState({
    data: [],
    loading: false,
  });
  const [retirementSummaryData, setRetirementSummaryData] = useState({
    data: [],
    loading: false,
  });

  const [selectedReadinessTier, setSelectedReadinessTier] = useState("");
  const [selectedRetirementTier, setSelectedRetirementTier] = useState("");
  const [isOpen, setIsopen] = useState({
    _id: null,
    open: false,
  });
  const [tierDetails, setTierDetails] = useState([]);

  const loadTierList = useCallback(async () => {
    if (tierType === PositionTier) {
      try {
        const result = await postData("filter-item/list", {
          sortQuery: { ["created_at"]: -1 },
          type: "position-group",
        });
        if (result.status === 200) {
          setTierDetails(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    }
  }, [tierType]);

  useEffect(() => {
    loadTierList();
  }, [loadTierList]);

  useEffect(() => {
    if (!loading && successors?.length <= 0) {
      const timer = setTimeout(() => {
        setShowSkeleton(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [loading, successors]);

  const heading = [
    {
      name: t("potential_predictor_score"),
      option: t("weight") + ": " + predictorWeight + "%",
      overall_score: predictorWeight,
      ordering: 0,
    },
    {
      name: t("senior_management_experience"),
      option: t("weight") + ": " + experienceWeight + "%",
      overall_score: experienceWeight,
      ordering: 1,
    },
    {
      name: t("conditions_of_concern_score"),
      option: t("weight") + ": " + concernsWeight + "%",
      overall_score: concernsWeight,
      ordering: 2,
    },
    {
      name: t("recent_performance_review"),
      option: t("weight") + ": " + performanceWeight + "%",
      overall_score: performanceWeight,
      ordering: 3,
    },
    {
      name: t("high_level_of_education"),
      option: t("weight") + ": " + educationWeight + "%",
      overall_score: educationWeight,
      ordering: 4,
    },
    {
      name: t("years_with_the_company"),
      option: t("weight") + ": " + yearWithCompanyWeight + "%",
      overall_score: yearWithCompanyWeight,
      ordering: 5,
    },
    {
      name: t("desire_to_advance"),
      option: '',//t("pass") + "/" + t("fail"),
      overall_score: 0,
      ordering: 6,
    },
    {
      name: t("loyalty_toward_company"),
      option: '',//t("pass") + "/" + t("fail"),
      overall_score: 0,
      ordering: 7,
    },
    {
      name: t("pending_retirement_window"),
      option: '',//t("pass") + "/" + t("fail"),
      overall_score: 0,
      ordering: 8,
    },
    {
      name: t("overall_weighted_score"),
      option: t("weight") + ": " + totalWeight + "%",
      overall_score: 0,
      ordering: 9,
    },
    {
      name: t("additional_comments"),
      option: "",
      overall_score: 0,
      ordering: 10,
    },
  ].sort((a, b) => b.overall_score - a.overall_score);

  const readinessHeading = [    
    {
      name: t("competency_fit"),
      option: "",
    },
    {
      name: t("cultural_fit"),
      option: "",
    },
    {
      name: t("readiness_timeframe"),
      option: "",
    },
    {
      name: t("additional_comments"),
      option: "",
    },
    {
      name: t("eliminated_candidate_due_to"),
      option: "",
    },
  ];

  useEffect(() => {
    if (role && role === "customer-boardmember" && path !== "change-password") {
      return navigate("/boardroom");
    }
  }, [role, path, navigate]);

  useEffect(() => {
    // Profiles List
    const loadSuccessors = async () => {
      try {
        const result = await postData("successor/list", {
          sortQuery: { created_at: 1 },
          is_interim: 2,
        });
        if (result.data) {
          setOwnSuccessors(
            result.data.map((value, key) => {
              let predictorCalculation =
                (predictorWeight * value?.overall_weighted_score) / 100;
              let experienceCalculation =
                (experienceWeight *
                  (value.experience_details
                    ? value?.experience_details[0]?.point
                    : 0)) /
                100;
              let concernsCalculation =
                (concernsWeight * value?.overall_score) / 100;
              let performanceCalculation =
                (performanceWeight *
                  (value.performance_details
                    ? value?.performance_details[0]?.point
                    : 0)) /
                100;
              let educationCalculation =
                (educationWeight *
                  (value.education_details
                    ? value?.education_details[0]?.point
                    : 0)) /
                100;
              let yearWithCompanyCalculation =
                (yearWithCompanyWeight *
                  (value.cu_details ? value?.cu_details[0]?.point : 0)) /
                100;
              let desireResult =
                value?.desire_details && value?.desire_details.length > 0
                  ? value?.desire_details[0]?.isPass
                    ? 1
                    : 2
                  : null;
              let loyaltyResult =
                value?.loyalty_details && value?.loyalty_details.length > 0
                  ? value?.loyalty_details[0]?.isPass
                    ? 1
                    : 2
                  : null;
              let RetirementResult =
                value?.retirement_details &&
                value?.retirement_details.length > 0
                  ? value?.retirement_details[0]?.isPass
                    ? 1
                    : 2
                  : null;
              return {
                ...value,
                overallWeightScore:
                  desireResult === 2 ||
                  loyaltyResult === 2 ||
                  RetirementResult === 2
                    ? 0.0
                    : (
                        parseFloat(predictorCalculation) +
                        parseFloat(experienceCalculation) +
                        parseFloat(concernsCalculation) +
                        parseFloat(performanceCalculation) +
                        parseFloat(educationCalculation) +
                        parseFloat(yearWithCompanyCalculation)
                      ).toFixed(2),
              };
            })
          );
        }
        setSuccessorCount(result.count);
        setIsSuccessorCount(true);
      } catch (err) {
        console.log(err.message);
      }
    };
    loadSuccessors();

    const detailsFun = async () => {
      setLoading(true);
      try {
        const result = await postData("emergency-replacement/details", {});
        if (result.data) {
          setDetails(result.data);
          setLoading(false);
        } else {
          setDetails({});
          setLoading(false);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    detailsFun();
  }, [
    isUpdate,
    concernsWeight,
    predictorWeight,
    educationWeight,
    experienceWeight,
    performanceWeight,
    yearWithCompanyWeight,
    user,
  ]);

  useEffect(() => {   
    async function retirementWindowData() {
      try {
        const result = await postData("experience/list", {
          sortQuery: { created_at: 1 },
          type: 3,
          status: 1,
          is_visabled: 1,
        });
        if (result.data) {
          setRetirementWindow(result.data);
        } else {
          console.log("Retirement window list message", result.message);
        }
      } catch (error) {
        console.log("Error retirement window list catch", error.message);
      }
    }
    retirementWindowData();

    const loaWeights = async () => {
      setIsUpdate(false);
      try {
        const result = await postData("scorecard/list", {
          status: 1,
        });
        if (result.data) {
          let total = 0;
          let pWeight = 0;
          let exWeight = 0;
          let con = 0;
          let pref = 0;
          let edu = 0;
          let ywc = 0;
          result.data.map((value, key) => {
            if (value.alias === "potential_predictor_score") {
              pWeight = value?.company_weight
                ? value?.company_weight
                : value?.weight;
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            } else if (value.alias === "executive_experience") {
              exWeight = value?.company_weight
                ? value?.company_weight
                : value?.weight;
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            } else if (value.alias === "concerns") {
              con = value?.company_weight
                ? value?.company_weight
                : value?.weight;
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            } else if (value.alias === "recent_performance_review") {
              pref = value?.company_weight
                ? value?.company_weight
                : value?.weight;
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            } else if (value.alias === "highest_level_education") {
              edu = value?.company_weight
                ? value?.company_weight
                : value?.weight;
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            } else if (value.alias === "years_with_company") {
              ywc = value?.company_weight
                ? value?.company_weight
                : value?.weight;
              total =
                total +
                Number(
                  value?.company_weight ? value?.company_weight : value?.weight
                );
            }
            setPredictorWeight(pWeight);
            setExperienceWeight(exWeight);
            setConcernWeight(con);
            setPerformanceWeight(pref);
            setEducationWeight(edu);
            setYearWithCompany(ywc);
            setTotalWeight(total);
            setIsUpdate(true);
            return value;
          });
        }
      } catch (err) {
        console.log(err.message);
        setIsUpdate(false);
      }
    };
    loaWeights();

    async function concernHeadingData() {
      try {
        const result = await postData("heading/list", {
          sortQuery: { created_at: 1 },
          status: 1,
          type: "concern",
          isTierSearch: true,
          tierType: tierType,
        });
        if (result.data) {
          setConcernHeadings(result.data);
        } else {
          console.log("Concern heading list message", result.message);
        }
      } catch (error) {
        console.log("Error concern heading list catch", error.message);
      }
    }
    concernHeadingData();

    async function predictorHeadingData() {
      try {
        const result = await postData("heading/list", {
          sortQuery: { created_at: 1 },
          status: 1,
          type: "predictors",
          isTierSearch: true,
          tierType: tierType,
        });
        if (result.data) {
          setPredictorsHeading(result.data);
        } else {
          console.log("Predictors heading list message", result.message);
        }
      } catch (error) {
        console.log("Error predictors heading list catch", error.message);
      }
    }
    predictorHeadingData();
  }, []);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "delete") {
      const loadDeleteRecord = async () => {
        setIsUpdate(false);
        try {
          const statusData = await postData("succession-plan/delete", {
            id: actionValue?.row_id,
          });
          if (statusData.data) {
            const index = successors.findIndex(
              (item) => item._id === actionValue?.row_id
            );
            if (index !== -1) {
              successors.splice(index, 1);
              setSuccessors(
                successors.map((it) => {
                  return it;
                })
              );
            }
            const userData = await postData(
              "verify-token",
              {},
              localStorage.getItem("accessToken")
            );
            if (userData?.data) {
              if (userData?.status && userData?.status === 200) {
                dispatch(authLogin(userData?.data));
              } else {
                dispatch(authLogout());
                localStorage.removeItem("accessToken");
                navigate("/signin");
              }
            }
            setIsUpdate(true);
          } else {
            toastr.error(statusData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      loadDeleteRecord();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionValue, dispatch]);

  const updateHandler = async (id, event) => {
    setLoading(true);
    try {
      const result = await postData("download-succession-plan/approved", {
        id: id,
        is_approved: event ? 1 : 2,
      });
      if (result.data) {
        toastr.success(result.message);
        setCurrentId("");
        setEnabledAlertPopup(false);
        setSuccessors(
          successors.map((item, key) => {
            if (item?._id === id) {
              return {
                ...item,
                is_approved: event ? 1 : 2,
              };
            } else {
              return item;
            }
          })
        );
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setCurrentId("");
      console.log(err.message);
    }
  }; 

  useEffect(() => {
    const loadSuccessors = async () => {
      setLoading(true);
      try {
        const result = await postData("highrated-successor/list", {
          is_interim: 2,
          isAllAvailable: 1,
        });
        if (result.data) {
          setSuccessors(
            result.data.map((item, key) => {
              if (
                item.successors_details &&
                item.successors_details.length > 0
              ) {
                let successors_details = item.successors_details.map(
                  (value, index) => {
                    let predictorCalculation =
                      (predictorWeight * value?.overall_weighted_score) / 100;
                    let experienceCalculation =
                      (experienceWeight *
                        (value.experience_details
                          ? value?.experience_details[0]?.point
                          : 0)) /
                      100;
                    let concernsCalculation =
                      (concernsWeight * value?.overall_score) / 100;
                    let performanceCalculation =
                      (performanceWeight *
                        (value.performance_details
                          ? value?.performance_details[0]?.point
                          : 0)) /
                      100;
                    let educationCalculation =
                      (educationWeight *
                        (value.education_details
                          ? value?.education_details[0]?.point
                          : 0)) /
                      100;
                    let yearWithCompanyCalculation =
                      (yearWithCompanyWeight *
                        (value.cu_details ? value?.cu_details[0]?.point : 0)) /
                      100;
                    let desireResult =
                      value?.desire_details && value?.desire_details.length > 0
                        ? value?.desire_details[0]?.isPass
                          ? 1
                          : 2
                        : null;
                    let loyaltyResult =
                      value?.loyalty_details &&
                      value?.loyalty_details.length > 0
                        ? value?.loyalty_details[0]?.isPass
                          ? 1
                          : 2
                        : null;
                    let RetirementResult =
                      value?.retirement_details &&
                      value?.retirement_details.length > 0
                        ? value?.retirement_details[0]?.isPass
                          ? 1
                          : 2
                        : null;
                    return {
                      ...value,
                      overallWeightScore:
                        desireResult === 2 ||
                        loyaltyResult === 2 ||
                        RetirementResult === 2
                          ? 0.0
                          : (
                              parseFloat(predictorCalculation) +
                              parseFloat(experienceCalculation) +
                              parseFloat(concernsCalculation) +
                              parseFloat(performanceCalculation) +
                              parseFloat(educationCalculation) +
                              parseFloat(yearWithCompanyCalculation)
                            ).toFixed(2),
                      desireResult: desireResult,
                      loyaltyResult: loyaltyResult,
                      RetirementResult: RetirementResult,
                    };
                  }
                );
                return {
                  _id: item?._id,
                  created_at: item?.created_at,
                  is_approved: item?.is_approved,
                  approved_date: item?.approved_date,
                  report_date: item?.report_date,
                  customer_admin_id: item?.customer_admin_id,
                  make_private: item?.make_private,
                  name: item.name,
                  position: item.position,
                  retirement: item.retirement,
                  pos_details: item.pos_details,
                  created_retirement_details: item.created_retirement_details,
                  successors_details: successors_details,
                  conclusion: item.conclusion,
                  plan_approve: item.plan_approve,
                  date: item.date,
                  signature: item.signature,
                  conclusion_name: item.conclusion_name,
                  isInvitedEmployee: item.isInvitedEmployee,
                  designation: item?.designation,
                  retirement_window: item?.retirement_window,
                  emergency_replacement_details:
                    item?.emergency_replacement_details,
                  conclusion_details: item?.conclusion_details,
                  role: item?.role_details,
                };
              } else {
                return {
                  _id: item?._id,
                  created_at: item?.created_at,
                  is_approved: item?.is_approved,
                  approved_date: item?.approved_date,
                  customer_admin_id: item?.customer_admin_id,
                  make_private: item?.make_private,
                  name: item.name,
                  position: item.position,
                  retirement: item.retirement,
                  pos_details: item.pos_details,
                  created_retirement_details: item.created_retirement_details,
                  conclusion: item.conclusion,
                  plan_approve: item.plan_approve,
                  date: item.date,
                  signature: item.signature,
                  conclusion_name: item.conclusion_name,
                  successors_details: [],
                  isInvitedEmployee: item.isInvitedEmployee,
                  designation: item?.designation,
                  retirement_window: item?.retirement_window,
                  emergency_replacement_details:
                    item?.emergency_replacement_details,
                  conclusion_details: item?.conclusion_details,
                  role: item?.role_details,
                };
              }
            })
          );
        }
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log(err.message);
      }
    };
    if (isUpdate) {
      loadSuccessors();
    }
  }, [
    isUpdate,
    concernsWeight,
    educationWeight,
    experienceWeight,
    performanceWeight,
    predictorWeight,
    yearWithCompanyWeight,
  ]);  

  const handleDownloadClick = async (e) => {
    e.preventDefault();
    // Open a blank tab immediately to avoid pop-up blockers.
    const newTab = window.open("", "_blank");
    // Display a styled loading message with Tailwind CSS.
    newTab.document.write(`
      <html lang="en">
        <head>
          <script src="https://cdn.tailwindcss.com"></script>
          <style>
            body {
              @apply bg-gray-100;
              margin: 0;
              height: 100vh;
            }
            .loader-container {
              @apply flex flex-col justify-center items-center h-screen;
            }
            .loader {
              width: 50px;
              aspect-ratio: 1;
              display: grid;
              border-radius: 50%;
              background:
                linear-gradient(0deg, rgb(0 0 0 / 50%) 30%, #0000 0 70%, rgb(0 0 0 / 100%) 0) 50% / 8% 100%,
                linear-gradient(90deg, rgb(0 0 0 / 25%) 30%, #0000 0 70%, rgb(0 0 0 / 75%) 0) 50% / 100% 8%;
              background-repeat: no-repeat;
              animation: l23 1s infinite steps(12);
            }
            .loader::before,
            .loader::after {
              content: "";
              grid-area: 1 / 1;
              border-radius: 50%;
              background: inherit;
              opacity: 0.915;
              transform: rotate(30deg);
            }
            .loader::after {
              opacity: 0.83;
              transform: rotate(60deg);
            }
            @keyframes l23 {
              100% {
                transform: rotate(1turn);
              }
            }
          </style>
        </head>
        <body>
          <div class="flex justify-center items-center mt-20 loader-container">
          <div class="flex flex-col items-center justify-center space-y-4">
            <div class="loader"></div>
            <p class="text-teal-700 text-lg font-semibold mt-4">Generating your PDF... Please wait.</p>
          </div>
         </div>
        </body>
      </html>
      `);
    try {
      // Generate the PDF blob asynchronously.
      const blob = await pdf(
        <SuccessionPlanAllReportMain
          successors={successors}
          heading={heading}
          readinessHeading={readinessHeading}
          concernHeadings={concernHeadings}
          predictorsHeading={predictorsHeading}
          user={user}
          details={details}
          companyLogo={API_URL + user?.image}
          tierType={tierType}
          tierDetails={tierDetails}
        />
      ).toBlob();

      // Create a URL from the blob.
      const blobURL = URL.createObjectURL(blob);
      // Redirect the new tab to the blob URL (load the PDF).
      newTab.location.href = blobURL;
    } catch (error) {
      // Display an error message in the new tab.
      newTab.document.body.innerHTML = `
        <div class="flex flex-col items-center justify-center h-screen bg-red-100">
          <p class="text-red-700 text-lg font-semibold">Failed to load PDF. Please try again later.</p>
          <p class="text-sm text-gray-600">${error.message}</p>
        </div>
      `;
      console.error("PDF generation error:", error);
    }
  };

  const handleSingleDownloadClick = async (e, item, index) => {
    e.preventDefault();
    // Open a blank tab immediately to avoid pop-up blockers.
    const newTab = window.open("", "_blank");
    // Display a styled loading message with Tailwind CSS.
    newTab.document.write(`
      <html lang="en">
        <head>
          <script src="https://cdn.tailwindcss.com"></script>
          <style>
            body {
              @apply bg-gray-100;
              margin: 0;
              height: 100vh;
            }
            .loader-container {
              @apply flex flex-col justify-center items-center h-screen;
            }
            .loader {
              width: 50px;
              aspect-ratio: 1;
              display: grid;
              border-radius: 50%;
              background:
                linear-gradient(0deg, rgb(0 0 0 / 50%) 30%, #0000 0 70%, rgb(0 0 0 / 100%) 0) 50% / 8% 100%,
                linear-gradient(90deg, rgb(0 0 0 / 25%) 30%, #0000 0 70%, rgb(0 0 0 / 75%) 0) 50% / 100% 8%;
              background-repeat: no-repeat;
              animation: l23 1s infinite steps(12);
            }
            .loader::before,
            .loader::after {
              content: "";
              grid-area: 1 / 1;
              border-radius: 50%;
              background: inherit;
              opacity: 0.915;
              transform: rotate(30deg);
            }
            .loader::after {
              opacity: 0.83;
              transform: rotate(60deg);
            }
            @keyframes l23 {
              100% {
                transform: rotate(1turn);
              }
            }
          </style>
        </head>
        <body>
         <div class="flex justify-center items-center mt-20 loader-container">
          <div class="flex flex-col items-center justify-center space-y-4">
            <div class="loader"></div>
            <p class="text-teal-700 text-lg font-semibold mt-4">Generating your PDF... Please wait.</p>
          </div>
         </div>
        </body>
      </html>
      `);

    try {
      // Generate the PDF blob asynchronously.
      const blob = await pdf(
        <Document>
          <SuccessionPlanReport
            key={index}
            successors={[item]}
            heading={heading}
            readinessHeading={readinessHeading}
            concernHeadings={concernHeadings}
            predictorsHeading={predictorsHeading}
            conclusion={item.conclusion ? item?.conclusion : []}
            planApprove={item?.plan_approve}
            name={item?.conclusion_name}
            date={item?.date}
            trimmedDataURL={item?.signature}
            is_approved={item?.is_approved}
            user={user}
            companyLogo={API_URL + user?.image}
            creatorPosition={
              item?.pos_details && item?.pos_details?.length > 0
                ? item?.pos_details[0]?.name
                : ""
            }
            creator={item?.name}
            tierType={tierType}
            tierDetails={tierDetails}
          />
          {item?.pos_details && item?.pos_details[0]?.code === "ceo" && (
            <EmergencyReplacementPlanReport
              data={details}
              details={item?.emergency_replacement_details}
              companyLogo={API_URL + user?.image}
            />
          )}
        </Document>
      ).toBlob();

      // Create a URL from the blob.
      const blobURL = URL.createObjectURL(blob);
      // Redirect the new tab to the blob URL (load the PDF).
      newTab.location.href = blobURL;
    } catch (error) {
      // Display an error message in the new tab.
      newTab.document.body.innerHTML = `
        <div class="flex flex-col items-center justify-center h-screen bg-red-100">
          <p class="text-red-700 text-lg font-semibold">Failed to load PDF. Please try again later.</p>
          <p class="text-sm text-gray-600">${error.message}</p>
        </div>
      `;
      console.error("PDF generation error:", error);
    }
  };

  useEffect(() => {
    let result2 = [];
    if (successors.length > 0) {
      successors.map((row) => {
        if (row.successors_details && row.successors_details.length > 0) {
          row.successors_details.map((item) => {
            result2.push({
              name: item?.name,
              successor_position: row.position,
              overall_score: item?.overallWeightScore,
              current_position: item?.position_details,
            });
            return item;
          });
        }
        return row;
      });
    }
    let mainResult = result2; //[...result,...result2];
    const group = groupBy(mainResult, "successor_position");
    //setHighScore(group);
  }, [ownSuccessor, successors]);

  const LoginAs = async (login_id) => {
    setIsChecking(false);
    return navigate("/login-as?user=" + login_id);
  };

  const loadReadinessList = useCallback(async () => {
    setReadinessData({
      data: [],
      loading: true,
    });
    try {
      const result = await postData("avarage-item", {
        type: "timeframe",
        tierId: selectedReadinessTier,
      });
      if (result.status === 200) {
        setReadinessData({
          data: result?.data,
          loading: false,
        });
      }else{
         setReadinessData({
          data: [],
          loading: false,
        });
      }
    } catch (err) {
      setReadinessData({
        data: [],
        loading: false,
      });
      console.log(err.message);
    }
  }, [selectedReadinessTier]);

  useEffect(() => {
    loadReadinessList();
  }, [loadReadinessList]);

  const loadRetirementSummaryList = useCallback(async () => {
    setRetirementSummaryData({
      data: [],
      loading: true,
    });
    try {
      const result = await postData("avarage-others", {
        type: 3,
        tierId: selectedRetirementTier,
      });
      if (result.status === 200) {
        setRetirementSummaryData({
          data: result?.data,
          loading: false,
        });
      }else{
        setRetirementSummaryData({
          data: [],
          loading: false,
        });
      }
    } catch (err) {
      setRetirementSummaryData({
        data: [],
        loading: false,
      });
      console.log(err.message);
    }
  }, [selectedRetirementTier]);

  useEffect(() => {
    loadRetirementSummaryList();
  }, [loadRetirementSummaryList]);

  return (
    <>
      <div className="relative">
        <div className="w-full mx-auto">
          <div className="relative flex justify-between items-center mb-4 flex-wrap sm:flex-nowrap gap-y-4 border-b border-slate-300">
            <div className="text-xl md:text-3xl text-slate-800 font-bold">
              {t("dashboard")}
            </div>
            <div className="sm:ml-auto flex justify-end items-center space-x-2 py-3 ">
              <DashboardButtonGroup
                isSuccessorCount={isSuccessorCount}
                successorCount={successorCount}
                id={id}
              />
              {isTrial !== 1 ? (
                <>
                  <Button
                    buttonType={"button"}
                    buttonIcon={"fa-light fa-person-circle-plus"}
                    buttonIconPosition={"left"}
                    buttonLabel={t("create_additional_plan")}
                    buttonHasLink={false}
                    functions={() => {
                      setPalnData({
                        type: 1,
                      });
                      let successionPlanCount = 0;
                      let totalSuccessionPlan = user?.number_of_succession_plan
                        ? user?.number_of_succession_plan
                        : 0;
                      if (user?.features && user?.features?.length > 0) {
                        successionPlanCount = user?.features?.find(
                          (it) => it?.code === "succession-plans-per-year"
                        )?.inputValue;
                      }
                      if (
                        successionPlanCount &&
                        successionPlanCount > totalSuccessionPlan
                      ) {
                        setEnabledAdditionalPlanPopup(true);
                      } else {
                        toastr.error(
                          SuccessonPlanLimitMessage(successionPlanCount)
                        );
                        setLoading(false);
                      }
                      setIsUpdate(false);
                    }}
                    buttonClasses={"!rounded-full !bg-black !text-white"}
                  />
                  {role && role === "customer-admin" && (
                    <Button
                      buttonType={"button"}
                      buttonIcon={"fa-light fa-clock"}
                      buttonIconPosition={"left"}
                      buttonLabel={t("send_reminder")}
                      buttonHasLink={false}
                      functions={() => {
                        setEnabledSendReminderPopup(true);
                      }}
                      buttonClasses={"!rounded-full"}
                    />
                  )}
                </>
              ) : (
                <Button
                  buttonType={"button"}
                  buttonClasses={
                    "!bg-slate-200 !text-slate-600 border border-slate-300 !rounded-full"
                  }
                  buttonIcon={"fa-light fa-person-circle-plus"}
                  buttonIconPosition={"left"}
                  buttonLabel={t("create_additional_plan")}
                  buttonHasLink={false}
                  functions={() => {
                    setEnabledTrialPopup(true);
                  }}
                />
              )}
            </div>
          </div>
          <div className="relative gap-4 mb-2">
            <EligibilityOverviewReport />
          </div>
          <div className="relative gap-4 mb-2">
            <AvgOfQuestionTier />
          </div>
          <div className="relative rounded divide-y divide-slate-200 mb-4 grid grid-cols-12 gap-5">
            <div className="col-span-8">
              <div className="py-4 px-4 flex flex-col bg-white rounded-lg shadow-md">
                <div className="flex justify-between items-center flex-wrap sm:flex-nowrap pb-1 mb-1">
                  <div className="text-base text-slate-800 font-bold leading-none">
                    {t("company_plan_tracking")}
                  </div>
                  <div className="sm:ml-auto flex justify-end items-center space-x-1">
                    {isTrial !== 1 ? (
                      <>
                        {/* <Button
                          buttonClasses={
                            "!py-0 !px-2 !border !border-teal-600 !flex !items-center !text-[10px] !bg-transparent !text-teal-600 !transition-all !duration-200"
                          }
                          buttonLabel={"Private My Succession Plan"}
                          buttonType={"button"}
                          buttonIcon={"fa-solid fa-key"}
                          buttonIconPosition={"left"}
                          buttonHasLink={false}
                          functions={() => {
                            setEnabledPrivatePopup(true);
                          }}
                        /> */}
                        <button
                          type="button"
                          className="flex justify-center items-center gap-2 bg-transparent text-teal-500 rounded text-sm h-8 py-0 px-2 transition-all duration-200 cursor-pointer"
                          onClick={handleDownloadClick}
                        >
                          <i className="fa-fw fa-regular fa-download"></i>
                          <div className="text-xs font-semibold whitespace-nowrap">
                            {t("download_all_completed_succession_plans")}
                          </div>
                        </button>
                      </>
                    ) : (
                      <Button
                        buttonClasses={
                          "!py-0 !px-2 !flex !items-center !text-[10px] !bg-transparent !text-slate-400 !transition-all !duration-200"
                        }
                        buttonLabel={t(
                          "download_all_completed_succession_plans"
                        )}
                        buttonType={"button"}
                        buttonIcon={"fa-regular fa-download"}
                        buttonIconPosition={"left"}
                        buttonHasLink={false}
                        functions={() => {
                          setEnabledTrialPopup(true);
                        }}
                      />
                    )}
                  </div>
                </div>

                <div
                  className={`py-3 border-y border-slate-200 space-y-2 ${
                    !showSkeleton ||
                    (!loading &&
                      "overflow-auto scroll-smooth scrollbar min-h-[493px]")
                  }`}
                >
                  {!loading && (
                    <div className="flex items-center w-full py-2 ">
                      <div className="w-2/5">
                        <div className="text-[10px] font-bold uppercase text-slate-600 leading-none">
                          {t("plan_position")}
                        </div>
                      </div>
                      <div className="w-[16%]">
                        <div className="text-[10px] font-bold uppercase text-slate-600 leading-none">
                          {t("invitation_date")}
                        </div>
                      </div>
                      <div className="w-[16%]">
                        <div className="text-[10px] font-bold uppercase text-slate-600 leading-none">
                          {t("completion_date")}
                        </div>
                      </div>
                      <div className="w-[16%]">
                        <div className="text-[10px] font-bold uppercase text-slate-600 leading-none">
                          {t("plan_status")}
                        </div>
                      </div>
                      {/* <div className="min-w-[100px] w-1/10">
                        <div className="text-[10px] font-bold uppercase text-slate-600 leading-none">
                          {t("make_plan_private")}
                        </div>
                      </div> */}
                      <div className="w-[16%]">
                        <div className="text-[10px] font-bold uppercase text-slate-600 leading-none">
                          {/* {t("approved_by_admin")} */}
                        </div>
                      </div>
                      <div className="w-[16%]">
                        <div className="text-[10px] font-bold uppercase text-slate-600 leading-none">
                          {t("download_plans")}
                        </div>
                      </div>
                      {/* <div className="min-w-[100px] w-1/10">
                    <div className="text-[10px] font-bold uppercase text-slate-600 leading-none">
                      {t('action')}
                    </div>
                  </div> */}
                    </div>
                  )}
                  {loading && <DashboardPlanTrackingSkeleton />}

                  {!loading &&
                    successors?.length > 0 &&
                    successors.map((item, index) => {
                      return (
                        <div
                          className={
                            "flex items-center w-full  rounded-lg border " +
                            (item?.isInvitedEmployee === 2
                              ? "bg-teal-100/50 border-teal-200"
                              : "border-slate-200")
                          }
                          key={item._id}
                        >
                          <div className="w-2/5 pl-2">
                            <div className="text-sm text-slate-800 font-medium capitalize">
                              {item?.name}
                            </div>
                            <div className="text-xs text-slate-400 font-medium capitalize">
                              {item?.position}
                            </div>
                          </div>
                          <div className="w-[16%]">
                            <div className="flex justify-start py-2 text-xs text-slate-500 font-medium">
                              {item && item?.created_at
                                ? moment(new Date(item?.created_at)).format(
                                    "ll"
                                  )
                                : "N/A"}
                            </div>
                          </div>
                          <div className="w-[16%]">
                            <div className="flex justify-start py-2 text-xs text-slate-500 font-medium">
                              {item && item?.date
                                ? moment(new Date(item?.date)).format("ll")
                                : "N/A"}
                            </div>
                          </div>
                          <div className="w-[16%]">
                            {item?.conclusion_details?.length > 0 ? (
                              <button
                                type={"button"}
                                className={
                                  "flex justify-center items-center font-medium gap-0.5 bg-transparent text-green-500 rounded text-xs "
                                }
                                //data-tooltip-id="not-completed-tooltip"
                                //data-tooltip-content={"Completed"}
                              >
                                <div
                                  className={
                                    "text-sm font-semibold whitespace-nowrap"
                                  }
                                >
                                  <i
                                    className={"fa-fw fa-solid fa-circle-check"}
                                  ></i>
                                </div>
                                {t("completed")}
                              </button>
                            ) : (
                              <>
                                <button
                                  type={"button"}
                                  className={
                                    "flex justify-center items-center font-medium gap-0.5 bg-transparent text-red-500 rounded text-xs "
                                  }
                                  //data-tooltip-id="not-completed-tooltip"
                                  //data-tooltip-content={"Not Completed"}
                                >
                                  <div
                                    className={
                                      "text-sm font-semibold whitespace-nowrap"
                                    }
                                  >
                                    <i
                                      className={
                                        "fa-fw fa-solid fa-circle-exclamation"
                                      }
                                    ></i>
                                  </div>
                                  {t("in_completed")}
                                </button>
                                {/* <Tooltip id="not-completed-tooltip" place="left"></Tooltip> */}
                              </>
                            )}
                          </div>
                          {/* <div className="min-w-[50px] w-1/10">
                            <Checkbox
                              checkboxLabel={""}
                              checkboxLableClass={"!text-xs !m-0"}
                              isChecked={
                                item?.make_private && item?.make_private === 1
                                  ? true
                                  : false
                              }
                              checkboxValue={item?._id}
                              getCheckboxValue={(code, event) => {
                                makePrivateHandler(
                                  item?._id,
                                  event.target.checked
                                );
                              }}
                              tooltipContent={""}
                            />
                          </div> */}
                          <div className="w-[16%]">
                            <div className="flex items-center justify-start space-x-1">
                              {item.successors_details.length > 0 ? (
                                <>
                                  {/* <Checkbox
                                    checkboxLabel={""}
                                    checkboxLableClass={"!text-xs !m-0"}
                                    isChecked={
                                      item?.is_approved &&
                                      item?.is_approved === 1
                                        ? true
                                        : false
                                    }
                                    checkboxValue={item?._id}
                                    getCheckboxValue={(code, event) => {
                                      if (event.target.checked === true) {
                                        updateHandler(
                                          item?._id,
                                          event.target.checked
                                        );
                                      } else {
                                        setEnabledAlertPopup(true);
                                        setCurrentId(item?._id);
                                      }
                                    }}
                                    tooltipContent={"Approved by the CEO"}
                                  />
                                  <Tooltip
                                    id="checkbox-tooltip"
                                    place="left"
                                  ></Tooltip> */}
                                  {item?.isInvitedEmployee === 1 ? (
                                    <>
                                      {user?.role_details[0]?.code ===
                                      "customer-admin" ? (
                                        <div
                                          data-tooltip-id="button-tooltip-edit"
                                          data-tooltip-content={"Edit"}
                                        >
                                          <Button
                                            buttonClasses={
                                              "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !text-teal-500 !w-4 !h-4"
                                            }
                                            buttonType={"button"}
                                            buttonIcon={"fa-regular fa-pencil"}
                                            buttonIconPosition={"left"}
                                            buttonLink={
                                              "/edit-user/" + item?._id
                                            }
                                            buttonHasLink={true}
                                          />
                                          <Tooltip
                                            id="button-tooltip-edit"
                                            place="left"
                                          ></Tooltip>
                                        </div>
                                      ) : item?.role[0]?.code !==
                                        "customer-admin" ? (
                                        <div
                                          data-tooltip-id="button-tooltip-edit"
                                          data-tooltip-content={"Edit"}
                                        >
                                          <Button
                                            buttonClasses={
                                              "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !text-teal-500 !w-4 !h-4"
                                            }
                                            buttonType={"button"}
                                            buttonIcon={"fa-regular fa-pencil"}
                                            buttonIconPosition={"left"}
                                            buttonLink={
                                              "/edit-user/" + item?._id
                                            }
                                            buttonHasLink={true}
                                          />
                                          <Tooltip
                                            id="button-tooltip-edit"
                                            place="left"
                                          ></Tooltip>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  ) : item?.isInvitedEmployee === 2 ? (
                                    <>
                                      <div
                                        data-tooltip-id="button-tooltip-edit"
                                        data-tooltip-content={"Edit"}
                                      >
                                        <Button
                                          buttonClasses={
                                            "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !text-teal-500 !w-4 !h-4"
                                          }
                                          buttonType={"button"}
                                          buttonIcon={"fa-regular fa-pencil"}
                                          buttonIconPosition={"left"}
                                          buttonHasLink={false}
                                          functions={() => {
                                            setPalnData({
                                              type: 1,
                                              name: item?.name,
                                              designation: item?.designation,
                                              retirement_window:
                                                item?.retirement_window,
                                              _id: item?._id,
                                            });
                                            setEnabledAdditionalPlanPopup(true);
                                            setIsUpdate(false);
                                          }}
                                        />
                                        <Tooltip
                                          id="button-tooltip-edit"
                                          place="left"
                                        ></Tooltip>
                                      </div>
                                      <Button
                                        buttonClasses={
                                          "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !text-teal-500 !w-4 !h-4"
                                        }
                                        buttonType={"button"}
                                        buttonIcon={"fa-regular fa-envelope"}
                                        buttonIconPosition={"left"}
                                        buttonHasLink={false}
                                        functions={() => {
                                          setPalnData({
                                            type: 2,
                                            _id: item?._id,
                                          });
                                          setEnabledAdditionalPlanPopup(true);
                                          setIsUpdate(false);
                                        }}
                                        tooltipContent={"Make Invited Employee"}
                                      />
                                      <Tooltip
                                        id="button-tooltip"
                                        place="left"
                                      ></Tooltip>
                                      <div
                                        className={
                                          "!text-teal-500 cursor-pointer text-xs"
                                        }
                                        data-tooltip-id="non-invited-tooltip"
                                        data-tooltip-content={
                                          "Non Invited Employee"
                                        }
                                      >
                                        <i
                                          onClick={() => {
                                            setIsChecking(true);
                                            LoginAs(item?._id);
                                          }}
                                          className={
                                            isChecking
                                              ? "fa-fw fa-regular fa-spinner fa-spin"
                                              : "fa-fw fa-regular fa-arrow-right-to-arc"
                                          }
                                        ></i>
                                      </div>
                                      <Tooltip
                                        id="non-invited-tooltip"
                                        place="left"
                                      ></Tooltip>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                <>
                                  {item?.isInvitedEmployee === 1 ? (
                                    <>
                                      {user?.role_details[0]?.code ===
                                      "customer-admin" ? (
                                        <div
                                          data-tooltip-id="button-tooltip-edit"
                                          data-tooltip-content={"Edit"}
                                        >
                                          <Button
                                            buttonClasses={
                                              "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !text-teal-500 !w-4 !h-4"
                                            }
                                            buttonType={"button"}
                                            buttonIcon={"fa-regular fa-pencil"}
                                            buttonIconPosition={"left"}
                                            buttonLink={
                                              "/edit-user/" + item?._id
                                            }
                                            buttonHasLink={true}
                                          />
                                          <Tooltip
                                            id="button-tooltip-edit"
                                            place="left"
                                          ></Tooltip>
                                        </div>
                                      ) : item?.role[0]?.code !==
                                        "customer-admin" ? (
                                        <div
                                          data-tooltip-id="button-tooltip-edit"
                                          data-tooltip-content={"Edit"}
                                        >
                                          <Button
                                            buttonClasses={
                                              "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !text-teal-500 !w-4 !h-4"
                                            }
                                            buttonType={"button"}
                                            buttonIcon={"fa-regular fa-pencil"}
                                            buttonIconPosition={"left"}
                                            buttonLink={
                                              "/edit-user/" + item?._id
                                            }
                                            buttonHasLink={true}
                                          />
                                          <Tooltip
                                            id="button-tooltip-edit"
                                            place="left"
                                          ></Tooltip>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  ) : item?.isInvitedEmployee === 2 ? (
                                    <>
                                      <div
                                        data-tooltip-id="button-tooltip-edit"
                                        data-tooltip-content={"Edit"}
                                      >
                                        <Button
                                          buttonClasses={
                                            "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !text-teal-500 !w-4 !h-4"
                                          }
                                          buttonType={"button"}
                                          buttonIcon={"fa-regular fa-pencil"}
                                          buttonIconPosition={"left"}
                                          buttonHasLink={false}
                                          functions={() => {
                                            setPalnData({
                                              type: 1,
                                              name: item?.name,
                                              designation: item?.designation,
                                              retirement_window:
                                                item?.retirement_window,
                                              _id: item?._id,
                                            });
                                            setEnabledAdditionalPlanPopup(true);
                                            setIsUpdate(false);
                                          }}
                                        />
                                        <Tooltip
                                          id="button-tooltip-edit"
                                          place="left"
                                        ></Tooltip>
                                      </div>
                                      <Button
                                        buttonClasses={
                                          "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !text-teal-500 !w-4 !h-4"
                                        }
                                        buttonType={"button"}
                                        buttonIcon={"fa-regular fa-envelope"}
                                        buttonIconPosition={"left"}
                                        buttonHasLink={false}
                                        functions={() => {
                                          setPalnData({
                                            type: 2,
                                            _id: item?._id,
                                          });
                                          setEnabledAdditionalPlanPopup(true);
                                          setIsUpdate(false);
                                        }}
                                        tooltipContent={"Make Invited Employee"}
                                      />
                                      <Tooltip
                                        id="button-tooltip"
                                        place="left"
                                      ></Tooltip>
                                      <div
                                        className={
                                          "!text-teal-500 cursor-pointer !text-xs"
                                        }
                                        data-tooltip-id="non-invited-tooltip"
                                        data-tooltip-content={
                                          "Non Invited Employee"
                                        }
                                      >
                                        <i
                                          onClick={() => {
                                            setIsChecking(true);
                                            LoginAs(item?._id);
                                          }}
                                          className={
                                            isChecking
                                              ? "fa-fw fa-regular fa-spinner fa-spin"
                                              : "fa-fw fa-regular fa-arrow-right-to-arc"
                                          }
                                        ></i>
                                      </div>
                                      <Tooltip
                                        id="non-invited-tooltip"
                                        place="left"
                                      ></Tooltip>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                              {user &&
                              user?.role_details[0]?.code === "customer-admin"
                                ? user?._id !== item?._id &&
                                  (role === "customer-admin" ||
                                    role === "customer-subadmin") && (
                                    <div
                                      data-tooltip-id="button-tooltip-delete"
                                      data-tooltip-content={"Delete"}
                                    >
                                      {item?._id !==
                                        item?.customer_admin_id && (
                                        <Button
                                          buttonClasses={
                                            "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !w-4 !h-4 !text-rose-500"
                                          }
                                          buttonType={"button"}
                                          buttonIcon={"fa-regular fa-trash-can"}
                                          buttonIconPosition={"left"}
                                          buttonHasLink={false}
                                          functions={() => {
                                            setCurrentId(item?._id);
                                            setenabledDeletePopup(true);
                                            setIsUpdate(false);
                                          }}
                                        />
                                      )}

                                      <Tooltip
                                        id="button-tooltip-delete"
                                        place="left"
                                      ></Tooltip>
                                    </div>
                                  )
                                : item?.role[0]?.code !== "customer-admin"
                                ? user?._id !== item?._id &&
                                  (role === "customer-admin" ||
                                    role === "customer-subadmin") && (
                                    <div
                                      data-tooltip-id="button-tooltip-delete"
                                      data-tooltip-content={"Delete"}
                                    >
                                      {item?._id !==
                                        item?.customer_admin_id && (
                                        <Button
                                          buttonClasses={
                                            "!p-0 !flex !items-center !justify-center !text-xs !bg-transparent !w-4 !h-4 !text-rose-500"
                                          }
                                          buttonType={"button"}
                                          buttonIcon={"fa-regular fa-trash-can"}
                                          buttonIconPosition={"left"}
                                          buttonHasLink={false}
                                          functions={() => {
                                            setCurrentId(item?._id);
                                            setenabledDeletePopup(true);
                                            setIsUpdate(false);
                                          }}
                                        />
                                      )}

                                      <Tooltip
                                        id="button-tooltip-delete"
                                        place="left"
                                      ></Tooltip>
                                    </div>
                                  )
                                : ""}
                            </div>
                          </div>
                          <div className="w-[16%]">
                            {item.successors_details.length > 0 ? (
                              <div className="flex items-start justify-start">
                                {((user && user?._id === item?._id) ||
                                  user?._id === item?.customer_admin_id ||
                                  (item?.make_private &&
                                    item?.make_private === 2)) && (
                                  <>
                                    {isTrial !== 1 ? (
                                      <>
                                        <div
                                          data-tooltip-id="button-tooltip-download"
                                          data-tooltip-content={"Download"}
                                        >
                                          <button
                                            type="button"
                                            className="flex justify-center items-center gap-2 bg-transparent text-teal-500 rounded text-sm h-8 py-0 px-2 transition-all duration-200 cursor-pointer"
                                            onClick={(e) =>
                                              handleSingleDownloadClick(
                                                e,
                                                item,
                                                index
                                              )
                                            }
                                          >
                                            <i className="fa-fw fa-regular fa-download"></i>
                                          </button>
                                          <Tooltip
                                            id="button-tooltip-download"
                                            place="left"
                                          ></Tooltip>
                                        </div>
                                      </>
                                    ) : (
                                      <div
                                        data-tooltip-id="button-tooltip-download"
                                        data-tooltip-content={"Download"}
                                      >
                                        <Button
                                          buttonClasses={
                                            "!p-0 !flex !items-center !justify-center !text-[10px] !bg-transparent !text-slate-400 !w-4 !h-4"
                                          }
                                          buttonType={"button"}
                                          buttonIcon={"fa-regular fa-download"}
                                          buttonIconPosition={"left"}
                                          buttonHasLink={false}
                                          functions={() => {
                                            setEnabledTrialPopup(true);
                                          }}
                                        />
                                        <Tooltip
                                          id="button-tooltip-download"
                                          place="left"
                                        ></Tooltip>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          {/* <div className="min-w-[100px] w-1/10">
                          </div>*/}
                        </div>
                      );
                    })}

                  {!loading && successors?.length <= 0 && (
                    <>
                      {showSkeleton ? (
                        <DashboardPlanTrackingSkeleton />
                      ) : (
                        <DashboardPlanTrackingSkeleton />
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-span-4 space-y-2">
              <DashBoardReportCenter />
            </div>
          </div>

          {/* <div className="relative grid grid-cols-12 gap-4 mt-4">
            <div className="col-span-4 space-y-2 flex">
              <CardTable
                newDesign={true}
                data={readinessData?.data?.map((item) => ({
                  _id: item?._id,
                  name: item?.title,
                  point: item?.number,
                }))}
                loading={readinessData?.loading}
                title={"Company Readiness Summary"}
                isShowTierList={tierType === PositionTier ? true : false}
                selectedTier={selectedReadinessTier}
                setSelectedTier={(e) => {
                  setSelectedReadinessTier(e);
                }}
              />
            </div>
            <div className="col-span-4 space-y-2 flex">
              <CardTable
                newDesign={true}
                data={retirementSummaryData?.data?.map((item) => ({
                  _id: item?._id,
                  name: item?.title,
                  point: item?.number,
                }))}
                loading={retirementSummaryData?.loading}
                title={"Company Retirement Summary"}
                isShowTierList={tierType === PositionTier ? true : false}
                selectedTier={selectedRetirementTier}
                setSelectedTier={(e) => {
                  setSelectedRetirementTier(e);
                }}
              />
            </div>
          </div> */}
        </div>
      </div>
      {enabledApprovalPopup && (
        <ApprovalPopup
          isOpen={enabledApprovalPopup}
          setIsOpen={(val) => setEnabledApprovalPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        ></ApprovalPopup>
      )}
      {enabledAlertPopup && (
        <AlertPopup
          isOpen={enabledAlertPopup}
          message={"Are you sure?"}
          setIsOpen={(val) => setEnabledAlertPopup(val)}
          getActionValue={(obj) => {
            updateHandler(currentId, false);
            //setActionValue(obj)
          }}
        ></AlertPopup>
      )}
      {enabledConfirmationPopup && (
        <ConfirmationPopup
          isOpen={enabledConfirmationPopup}
          title={"Confirmation"}
          message={
            "By checking this box you will allow the user administrator access to all plans and information within the company account."
          }
          confirmButtonLabel={"Confirm Additional Admin"}
          cancelButtonLabel={"Decline"}
          setIsOpen={(val) => setEnabledConfirmationPopup(val)}
          getActionValue={(obj) => {
            //updateHandler(currentId,false)
            setActionValue(obj);
          }}
        />
      )}
      {enabledAdditionalPlanPopup && (
        <AdditionalPlanPopup
          isOpen={enabledAdditionalPlanPopup}
          setIsOpen={(val) => setEnabledAdditionalPlanPopup(val)}
          data={planData}
          getActionValue={(obj) => {
            setActionValue(obj);
            setIsUpdate(true);
          }}
        ></AdditionalPlanPopup>
      )}
      {enabledDeletePopup && (
        <DeletePopup
          isOpen={enabledDeletePopup}
          setIsOpen={(val) => setenabledDeletePopup(val)}
          currentId={currentId}
          forClerify={'user-delete'}
          getActionValue={(obj) => {
            setActionValue(obj);
            setenabledDeletePopup(false);
            setCurrentId("");
          }}
        />
      )}
      {enabledTrialPopup && (
        <TrialAlertPopup
          isOpen={enabledTrialPopup}
          setIsOpen={(val) => setEnabledTrialPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        />
      )}
      {enabledSendReminderPopup && (
        <SendReminderPopup
          isOpen={enabledSendReminderPopup}
          setIsOpen={(val) => setEnabledSendReminderPopup(val)}
          data={planData}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        />
      )}
      {enabledPrivatePopup && (
        <ConfirmationPopup
          isOpen={enabledPrivatePopup}
          title={"Confirmation"}
          message={
            "Are you sure you want to proceed with making your Succession Plan private? Please click 'Confirm' to finalize this action."
          }
          confirmButtonLabel={"Confirm"}
          cancelButtonLabel={"Cancel"}
          setIsOpen={(val) => setEnabledPrivatePopup(val)}
          getActionValue={(obj) => {
            //updateHandler(currentId,false)
            // setActionValue(obj);
          }}
        />
      )}
      {isOpen?.open && (
        <AddEditCompanyPosition
          isOpen={isOpen?.open}
          id={isOpen?._id}
          setIsOpen={setIsopen}
          //loadPositionList={loadPosition}
        />
      )}
    </>
  );
};

export default Dashboard;
